import { render } from "./ArticleGrid.vue?vue&type=template&id=a21ec4c2&scoped=true"
import script from "./ArticleGrid.vue?vue&type=script&lang=js"
export * from "./ArticleGrid.vue?vue&type=script&lang=js"

import "./ArticleGrid.vue?vue&type=style&index=0&id=a21ec4c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a21ec4c2"]])

export default __exports__